var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationInactive = function SvgNotificationInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M11.167 5.903v3.053M11.185 1.833A6.103 6.103 0 0 0 5.08 7.938v1.925c0 .623-.257 1.558-.578 2.09l-1.164 1.943c-.715 1.201-.22 2.54 1.1 2.98a21.4 21.4 0 0 0 13.503 0 2.035 2.035 0 0 0 1.1-2.98l-1.164-1.943c-.321-.532-.578-1.476-.578-2.09V7.938c-.009-3.355-2.759-6.105-6.114-6.105Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeMiterlimit: 10,
    d: "M14.219 17.252a3.063 3.063 0 0 1-3.053 3.053 3.06 3.06 0 0 1-2.154-.899 3.06 3.06 0 0 1-.898-2.154"
  })));
};
export default SvgNotificationInactive;